import React from "react";
import { FormattedMessage, useIntl, defineMessage } from "react-intl";
import { Text } from "@vagastec/ensemble-core";
import { Alert } from "./components/alert";
import { Select } from "./components/select";
import { Space } from "./components/space";
import { Input } from "./components/input";
import { containerSalario, infoIconContainer } from "./step-1.css";
import { InfoIcon } from "./icons/info-icon";
import { Fieldset } from "./components/fieldset";
import { Switch } from "./components/switch";
import { wrapperTooltipStyle } from "./components/tooltip.css";
import { Tooltip } from "./components/tooltip";

export function Salario({ formState, setFormState }) {
  const intl = useIntl();
  const [hasTriedToSubmit, setHasTriedToSubmit] = React.useState(false);
  const [active, setActive] = React.useState(false);

  return (
    <>
      <Alert>
        <div className={infoIconContainer}>
          <InfoIcon width={20} height={20} />
        </div>
        <Text size="sm" as="p">
          <FormattedMessage
            id="step1.infoSalario"
            defaultMessage="Informe o salário como filtro para <strong>recomendarmos profissionais mais aderentes</strong>. Você pode escolher exibir os valores no anúncio."
            values={{
              strong: (chunks) => <strong>{chunks}</strong>,
            }}
          />
        </Text>
      </Alert>

      <div className={containerSalario}>
        <div>
          <Text size="rg" as="h2" weight={600}>
            <FormattedMessage id="step1.moeda" defaultMessage="Moeda" />
          </Text>
          <Space height=".5rem" />
          <Select
            aria-label="moeda"
            value={formState.salarioMoeda ?? ""}
            onChange={(e) => setFormState({ salarioMoeda: e.target.value })}
            data-testid="select-moeda"
          >
            <option value="BRL">
              {" "}
              {intl.formatMessage(
                defineMessage({
                  id: "step1.moedaReal",
                  defaultMessage: "Real",
                })
              )}
            </option>
            <option value="USD">
              {" "}
              {intl.formatMessage(
                defineMessage({
                  id: "step1.moedaDolar",
                  defaultMessage: "Dólar",
                })
              )}
            </option>
          </Select>
        </div>

        <Input
          label={
            <FormattedMessage id="step1.valorMinimo" defaultMessage="Mínimo" />
          }
          type="number"
          value={formState.salarioFaixaValorInicial}
          onChange={(e) =>
            setFormState({
              salarioFaixaValorInicial: Number(e.target.value),
            })
          }
          min={formState.exibirSalario ? 1 : 0}
          validate={(isValidInternally) => {
            return (
              isValidInternally &&
              formState.salarioFaixaValorInicial <=
                formState.salarioFaixaValorFinal
            );
          }}
          errorMessage={
            <FormattedMessage
              id="step1.erroSalario"
              defaultMessage="Faixa salarial inválida"
            />
          }
          data-testid="input-valor-minimo"
          required={formState.exibirSalario}
          shouldValidate={hasTriedToSubmit}
          format="currency"
          currency={formState.salarioMoeda}
        />

        <Input
          label={
            <FormattedMessage id="step1.valorMaximo" defaultMessage="Máximo" />
          }
          type="number"
          value={formState.salarioFaixaValorFinal}
          onChange={(e) =>
            setFormState({
              salarioFaixaValorFinal: Number(e.target.value),
            })
          }
          min={formState.exibirSalario ? 1 : 0}
          validate={(isValidInternally) =>
            isValidInternally &&
            formState.salarioFaixaValorInicial <=
              formState.salarioFaixaValorFinal
          }
          errorMessage={
            <FormattedMessage
              id="step1.erroSalario"
              defaultMessage="Faixa salarial inválida"
            />
          }
          data-testid="input-valor-maximo"
          required={formState.exibirSalario}
          shouldValidate={hasTriedToSubmit}
          format="currency"
          currency={formState.salarioMoeda}
        />
      </div>
      <Space />
      <Fieldset
        title={
          <FormattedMessage
            id="step1.titleExibirSalario"
            defaultMessage="Exibir no anúncio"
          />
        }
      >
        <div className={wrapperTooltipStyle}>
          <Switch
            label={
              <FormattedMessage
                id="step1.switchExibirSalario"
                defaultMessage="Exibir informações salariais no anúncio"
              />
            }
            checked={formState.exibirSalario}
            onChange={(e) => setFormState({ exibirSalario: e.target.checked })}
            data-testid="switch-exibir-salario"
          />
          <Tooltip
            active={active}
            setActive={setActive}
            text={
              <FormattedMessage
                id="step1.tooltipSalario"
                defaultMessage="Se esta opção estiver desativada, o salário será exibido como a combinar"
              />
            }
          />
        </div>
      </Fieldset>
    </>
  );
}
